import { styled } from "@mui/material";
import LoadingScreen from "./LoadingScreen";

type LoadingStreamProps = {
  loadingText?: string;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function LoadingStream({ loadingText }: LoadingStreamProps) {
  return (
    <Container>
      {/* <Box sx={{ mt: 7 }}>{loadingText ?? "Connecting your interactive experience..."}</Box> */}
      <LoadingScreen
        text={"Connecting your interactive experience..."}
        textStyle={{ color: "#fff" }}
      />
    </Container>
  );
}

const Container = styled("div")(({ theme }) => ({
  color: "black",
  position: "absolute",
  gridColumnStart: 1,
  gridColumnEnd: 2,
  gridRowStart: 1,
  gridRowEnd: 2,
  placeSelf: "center",
  padding: theme.spacing(4),
  display: "flex",
  width: "90%",
  maxWidth: "600px",
  flexDirection: "column",
  top: "50%",
  transform: "translateY(-50%)",
  borderRadius: theme.shape.borderRadius,
  [theme.breakpoints.down("md")]: {
    top: "40%",
  },
}));
